import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  interfaceData: [],
  destinationTablesData: [],
  uniqueDefinitionData: [],
  loading: false,
  selectedInterface: null,
  selectedInterfaceCreateScreen: {},
  selectedDestinationTable: null,
  selectedDestinationTableCreateScreen: {},
  rowFilteringDataForPayload: null,
  lookupFieldDataForPayload: null,
  isPreviewEmpty: true,
  sort: {
    keytoSort: "id",
    direction: "asc",
  },
  selectedUniqueDefID: null,
  selectedUniqueDefInterfaceName: null,
  selectedUniqueDefDestinationTable: null,
  isLookupFieldsValid: false,
  //For Edit Screen
  initialEditData: {},
  editID: null,
  uniqueDefinitionDataAll: [],
  uniqueDefExecuteQueryDataForBrands: [],

  //For Duplicate Screen
  initialDuplicateData: {},
  dupID: null,
  selectedInterfaceDuplicateScreen: {},
  selectedDestinationTableDuplicateScreen: {},
  //Global State
  filteringDefJSONOutput: null,
  isValidRowFiltering: false,
};

const uniqueDefinitionSlice = createSlice({
  name: "uniqueDefinition",
  initialState: initialState,
  reducers: {
    setInterfaceData: (state, action) => {
      state.interfaceData = action.payload;
    },
    setDestinationTablesData: (state, action) => {
      state.destinationTablesData = action.payload;
    },
    setUniqueDefinitionData: (state, action) => {
      state.uniqueDefinitionData = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSelectedInterface: (state, action) => {
      state.selectedInterface = action.payload;
    },
    setSelectedInterfaceCreateScreen: (state, action) => {
      state.selectedInterfaceCreateScreen = action.payload;
    },
    setSelectedDestinationTable: (state, action) => {
      state.selectedDestinationTable = action.payload;
    },
    setSelectedDestinationTableCreateScreen: (state, action) => {
      state.selectedDestinationTableCreateScreen = action.payload;
    },
    setRowFilteringDataForPayload: (state, action) => {
      state.rowFilteringDataForPayload = action.payload;
    },
    setLookupFieldDataForPayload: (state, action) => {
      state.lookupFieldDataForPayload = action.payload;
    },
    setSort: (state, action) => {
      state.sort = action.payload;
    },

    setUniqueDefinitionDataAll: (state, action) => {
      state.uniqueDefinitionDataAll = action.payload;
    },
    setUniqueDefExecuteQueryDataForBrands: (state, action) => {
      state.uniqueDefExecuteQueryDataForBrands = action.payload;
    },
    setInitialEditData: (state, action) => {
      state.initialEditData = action.payload;
    },
    //For Duplicate Screen
    setInitialDuplicateData: (state, action) => {
      state.initialDuplicateData = action.payload;
    },
    setSelectedUniqueDefID: (state, action) => {
      state.selectedUniqueDefID = action.payload;
    },
    setSelectedUniqueDefInterfaceName: (state, action) => {
      state.selectedUniqueDefInterfaceName = action.payload;
    },
    setSelectedUniqueDefDestinationTable: (state, action) => {
      state.selectedUniqueDefDestinationTable = action.payload;
    },
    setFilteringDefJSONOutput: (state, action) => {
      state.filteringDefJSONOutput = action.payload;
    },
    setIsValidRowFiltering: (state, action) => {
      state.isValidRowFiltering = action.payload;
    },
    setSelectedInterfaceDuplicateScreen: (state, action) => {
      state.selectedInterfaceDuplicateScreen = action.payload;
    },
    setSelectedDestinationTableDuplicateScreen: (state, action) => {
      state.selectedDestinationTableDuplicateScreen = action.payload;
    },
    setIsPreviewEmpty: (state, action) => {
      state.isPreviewEmpty = action.payload;
    },
    setEditID: (state, action) => {
      state.editID = action.payload;
    },
    setDupID: (state, action) => {
      state.dupID = action.payload;
    },
    setIsLookupFieldsValid: (state, action) => {
      state.isLookupFieldsValid = action.payload;
    },
  },
});

export const {
  setInterfaceData,
  setDestinationTablesData,
  setUniqueDefinitionData,
  setLoading,
  setSelectedInterface,
  setSelectedInterfaceCreateScreen,
  setSelectedDestinationTable,
  setSelectedDestinationTableCreateScreen,
  setRowFilteringDataForPayload,
  setSort,
  setLookupFieldDataForPayload,
  setUniqueDefinitionDataAll,
  setInitialEditData,
  setInitialDuplicateData,
  setUniqueDefExecuteQueryDataForBrands,
  setSelectedUniqueDefID,
  setSelectedUniqueDefInterfaceName,
  setSelectedUniqueDefDestinationTable,
  setFilteringDefJSONOutput,
  setIsValidRowFiltering,
  setSelectedInterfaceDuplicateScreen,
  setSelectedDestinationTableDuplicateScreen,
  setIsPreviewEmpty,
  setEditID,
  setDupID,
  setIsLookupFieldsValid,
} = uniqueDefinitionSlice.actions;
export default uniqueDefinitionSlice.reducer;
